document.addEventListener("DOMContentLoaded", () => {
  const checkboxes = document.querySelectorAll(".sds-gift-addon-checkbox");

  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", () => {
      const productId = checkbox.getAttribute("data-product-id");

      if (checkbox.checked) {
        // Add the product to the cart
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: productId,
            quantity: 1,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Product added to cart:", data);

            // Check cart type and redirect accordingly
            const cartType = Shopify.theme.settings.cart_type; // Assuming 'cart_type' is set in theme settings
            if (cartType === "page") {
              // Redirect to cart page
              window.location.href = routes.cart_url;
            } else {
              // Open the cart drawer for other cart types
              const cartDrawer = document.querySelector("cart-drawer");
              if (cartDrawer) {
                cartDrawer.classList.remove("is-empty");
                fetch("/cart?view=drawer")
                  .then((response) => response.text())
                  .then((html) => {
                    const tempDiv = document.createElement("div");
                    tempDiv.innerHTML = html;
                    const newDrawerContent =
                      tempDiv.querySelector("#CartDrawer");
                    document.querySelector("#CartDrawer").innerHTML =
                      newDrawerContent.innerHTML;
                    cartDrawer.open();
                  });
              }
            }
          })
          .catch((error) => {
            console.error("Error adding product to cart:", error);
          });
      } else {
        // Handle product removal if unchecked
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: productId,
            quantity: 0,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Product removed from cart:", data);
          })
          .catch((error) => {
            console.error("Error removing product from cart:", error);
          });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Get the main gift checkbox and the addon container
  const giftCheckbox = document.getElementById("gift-checkbox-field");
  const giftAddonContainer = document.querySelector(
    ".sds-gift-addon-container"
  );
  const checkboxes = document.querySelectorAll(".sds-gift-addon-checkbox");

  // Function to show/hide gift box options
  giftCheckbox.addEventListener("change", function () {
    if (giftCheckbox.checked) {
      giftAddonContainer.style.display = "grid";
    } else {
      giftAddonContainer.style.display = "none";

      // Uncheck all product checkboxes when main gift checkbox is unchecked
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    }
  });
});
